/* eslint-disable @typescript-eslint/no-explicit-any */
import * as outlineIcons from '@heroicons/react/24/outline'
import * as solidIcons from '@heroicons/react/24/solid'

export const heroIcons = {
  'home-outline': (props: any) => <outlineIcons.HomeIcon {...props} />,
  'home-solid': (props: any) => <solidIcons.HomeIcon {...props} />,
  'magnifying-glass-solid': (props: any) => <solidIcons.MagnifyingGlassIcon {...props} />,
  'bell-solid': (props: any) => <solidIcons.BellIcon {...props} />,
  'bell-outline': (props: any) => <outlineIcons.BellIcon {...props} />,
  'adjustments-vertical-outline': (props: any) => <outlineIcons.AdjustmentsVerticalIcon {...props} />,
  'adjustments-vertical-solid': (props: any) => <solidIcons.AdjustmentsVerticalIcon {...props} />,
  'light-bulb-solid': (props: any) => <solidIcons.LightBulbIcon {...props} />,
  'light-bulb-outline': (props: any) => <outlineIcons.LightBulbIcon {...props} />,
  'presentation-chart-bar-outline': (props: any) => <outlineIcons.PresentationChartBarIcon {...props} />,
  'presentation-chart-bar-solid': (props: any) => <solidIcons.PresentationChartBarIcon {...props} />,
  'arrow-trending-up-outline': (props: any) => <outlineIcons.ArrowTrendingUpIcon {...props} />,
  'arrow-trending-up-solid': (props: any) => <solidIcons.ArrowTrendingUpIcon {...props} />,
  'arrow-trending-down-outline': (props: any) => <outlineIcons.ArrowTrendingDownIcon {...props} />,
  'arrow-trending-down-solid': (props: any) => <solidIcons.ArrowTrendingDownIcon {...props} />,
  'cog-8-tooth-outline': (props: any) => <outlineIcons.Cog8ToothIcon {...props} />,
  'cog-8-tooth-solid': (props: any) => <solidIcons.Cog8ToothIcon {...props} />,
  'chevron-double-left-outline': (props: any) => <outlineIcons.ChevronDoubleLeftIcon {...props} />,
  'chevron-double-left-solid': (props: any) => <solidIcons.ChevronDoubleLeftIcon {...props} />,
  'chevron-double-right-outline': (props: any) => <outlineIcons.ChevronDoubleRightIcon {...props} />,
  'chevron-double-right-solid': (props: any) => <solidIcons.ChevronDoubleRightIcon {...props} />,
  'chevron-double-up-outline': (props: any) => <outlineIcons.ChevronDoubleUpIcon {...props} />,
  'chevron-double-up-solid': (props: any) => <solidIcons.ChevronDoubleUpIcon {...props} />,
  'chevron-double-down-outline': (props: any) => <outlineIcons.ChevronDoubleDownIcon {...props} />,
  'chevron-double-down-solid': (props: any) => <solidIcons.ChevronDoubleDownIcon {...props} />,
  'chevron-left-outline': (props: any) => <outlineIcons.ChevronLeftIcon {...props} />,
  'chevron-left-solid': (props: any) => <solidIcons.ChevronLeftIcon {...props} />,
  'chevron-right-outline': (props: any) => <outlineIcons.ChevronRightIcon {...props} />,
  'chevron-right-solid': (props: any) => <solidIcons.ChevronRightIcon {...props} />,
  'chevron-down-solid': (props: any) => <solidIcons.ChevronDownIcon {...props} />,
  'chevron-down-outline': (props: any) => <outlineIcons.ChevronDownIcon {...props} />,
  'chevron-up-solid': (props: any) => <solidIcons.ChevronUpIcon {...props} />,
  'chevron-up-outline': (props: any) => <outlineIcons.ChevronUpIcon {...props} />,
  'bel-outline': (props: any) => <outlineIcons.BellIcon {...props} />,
  'bel-solid': (props: any) => <solidIcons.BellIcon {...props} />,
  'question-mark-circle': (props: any) => <solidIcons.QuestionMarkCircleIcon {...props} />,
  organization: (props: any) => <outlineIcons.BuildingOfficeIcon {...props} />,
  user: (props: any) => <outlineIcons.UserCircleIcon {...props} />,
  'plus-small': (props: any) => <solidIcons.PlusSmallIcon {...props} />,
  'minus-small': (props: any) => <solidIcons.MinusSmallIcon {...props} />,
  'arrow-left': (props: any) => <outlineIcons.ArrowLeftIcon {...props} />,
  'arrow-right': (props: any) => <outlineIcons.ArrowRightIcon {...props} />,
  'arrow-left-right': (props: any) => <outlineIcons.ArrowsRightLeftIcon {...props} />,
  'arrow-right-small': (props: any) => <outlineIcons.ArrowSmallRightIcon {...props} />,
  'arrow-up': (props: any) => <outlineIcons.ArrowUpIcon {...props} />,
  'arrow-down': (props: any) => <outlineIcons.ArrowDownIcon {...props} />,
  'arrow-trending-up': (props: any) => <outlineIcons.ArrowTrendingUpIcon {...props} />,
  'arrow-trending-down': (props: any) => <outlineIcons.ArrowTrendingDownIcon {...props} />,
  'x-mark': (props: any) => <solidIcons.XMarkIcon {...props} />,
  'cog-8-tooth': (props: any) => <outlineIcons.Cog8ToothIcon {...props} />,
  speed: (props: any) => <outlineIcons.BoltIcon {...props} />,
  brightness: (props: any) => <outlineIcons.SunIcon {...props} />,
  'magnifying-glass-plus': (props: any) => <outlineIcons.MagnifyingGlassPlusIcon {...props} />,
  'exclamation-circle': (props: any) => <outlineIcons.ExclamationCircleIcon {...props} />,
  'exclamation-triangle': (props: any) => <outlineIcons.ExclamationTriangleIcon {...props} />,
  'exclamation-triangle-solid': (props: any) => <solidIcons.ExclamationTriangleIcon {...props} />,
  'information-circle-solid': (props: any) => <solidIcons.InformationCircleIcon {...props} />,
  'academic-cap': (props: any) => <outlineIcons.AcademicCapIcon {...props} />,
  'exclamation-circle-outline': (props: any) => <outlineIcons.ExclamationCircleIcon {...props} />,
  'computer-desktop-outline': (props: any) => <outlineIcons.ComputerDesktopIcon {...props} />,
  sparkles: (props: any) => <outlineIcons.SparklesIcon {...props} />,
  'link-hero-icons': (props: any) => <outlineIcons.LinkIcon {...props} />,
  key: (props: any) => <outlineIcons.KeyIcon {...props} />,
  'shield-check-solid': (props: any) => <solidIcons.ShieldCheckIcon {...props} />,
  photo: (props: any) => <outlineIcons.PhotoIcon {...props} />,
  play: (props: any) => <outlineIcons.PlayIcon {...props} />,
  pause: (props: any) => <outlineIcons.PauseIcon {...props} />,
  swatch: (props: any) => <outlineIcons.SwatchIcon {...props} />,
  minus: (props: any) => <outlineIcons.MinusIcon {...props} />,
  scale: (props: any) => <outlineIcons.ScaleIcon {...props} />,
  xCircleSolid: (props: any) => <solidIcons.XCircleIcon {...props} />,
  videoCamera: (props: any) => <outlineIcons.VideoCameraIcon {...props} />,
  save: (props: any) => <outlineIcons.BookmarkIcon {...props} />,
  map: (props: any) => <outlineIcons.MapIcon {...props} />,
  lifebuoy: (props: any) => <outlineIcons.LifebuoyIcon {...props} />,
  'wrench-screwdriver': (props: any) => <outlineIcons.WrenchScrewdriverIcon {...props} />,
  language: (props: any) => <outlineIcons.LanguageIcon {...props} />,
  'code-bracket': (props: any) => <outlineIcons.CodeBracketIcon {...props} />,
  server: (props: any) => <outlineIcons.ServerIcon {...props} />,
  'map-pin': (props: any) => <outlineIcons.MapPinIcon {...props} />,
  'viewfinder-circle': (props: any) => <outlineIcons.ViewfinderCircleIcon {...props} />,
  truck: (props: any) => <outlineIcons.TruckIcon {...props} />,
  'clock-outline': (props: any) => <outlineIcons.ClockIcon {...props} />,
  calendar: (props: any) => <outlineIcons.CalendarIcon {...props} />,
  folder: (props: any) => <outlineIcons.FolderIcon {...props} />,
  wifi: (props: any) => <outlineIcons.WifiIcon {...props} />,
  lockClosedSolid: (props: any) => <solidIcons.LockClosedIcon {...props} />,
  'paper-airplane': (props: any) => <outlineIcons.PaperAirplaneIcon {...props} />,
  'camera-outline': (props: any) => <outlineIcons.CameraIcon {...props} />,
  trash: (props: any) => <outlineIcons.TrashIcon {...props} />,
}
